import "./paymentbutton.scss"

const ready = (fn) => {
    if (document.readyState != 'loading'){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

const baseUrl = ASKELL_BASE_URL;
const cdnBaseUrl = ASKELL_CDN_BASE_URL;
const styleUrl = cdnBaseUrl + 'js/dist/paymentbutton.css';

const appendStyleSheet = () => {
    var styleElement = document.createElement("link");
    styleElement.setAttribute("rel", "stylesheet");
    styleElement.setAttribute("href", styleUrl);
    document.head.appendChild(styleElement);
}

const createModal = (brand=true) => {
    var modal = document.createElement("div");
    modal.setAttribute("id", "askell-modal");
    var classes = "askell-modal"
    if (brand) {
        classes += " brand"
    }
    modal.setAttribute("class", classes);
    return modal;
}


const createModalFooter = () => {
    var modalFooter = document.createElement("div");
    modalFooter.setAttribute("id", "brand-footer")
    modalFooter.setAttribute("class", "brand-footer")
    modalFooter.innerHTML = '<ul><li><a href="https://askell.is/" target="_blank">© Áskell 2021</a></li><!--<li><a>Notendaskilmálar</a></li><li><a>Leiðbeiningar</a></li>--></ul>';
    return modalFooter;
}

const createModalOverlay = () => {
    var modalOverlay = document.createElement("div");
    modalOverlay.setAttribute("id", "askell-modal-overlay");
    modalOverlay.setAttribute("class", "askell-modal-overlay");
    return modalOverlay;
}

const createModalCloseButton = () => {
    var button = document.createElement("div");
    var span = document.createElement("span");
    span.setAttribute("class", "sr-only");
    span.textContent = "Loka"
    button.appendChild(span)
    button.setAttribute("class", "askell-close-button")
    button.addEventListener("click", closeModal)
    return button
}


const createIframe = (planId, reference=null, amount=null, redirect=null) => {
    var url = `${baseUrl}subscribe-button/${planId}/?`;
    var urlParams = {}
    if(amount) {
        urlParams['amount'] = amount
    }
    if(reference) {
        urlParams['reference'] = reference
    }
    if(redirect)  {
        urlParams['redirect'] = btoa(redirect)
    }
    for (const [key, value] of Object.entries(urlParams)) {
        url += `&${key}=${value}`
    }
    var div = document.createElement("div");
    div.setAttribute("class", "askell-iframe-container")
    var iframe = document.createElement("iframe");
    iframe.setAttribute("id", "askell-iframe");
    iframe.setAttribute("src", url);
    
    iframe.setAttribute("onLoad", "this.contentWindow.focus();this.style.visibility='visible';");
    iframe.style.visibility = "hidden";
    div.appendChild(iframe)
    return div
}

const openPaymentModal = (configuration, reference, amount, redirect) => {
    var planId = configuration.plan
    var accountId = configuration.account
    var brand = configuration.brand
    var modal = createModal(brand)
    var brandingDiv = document.createElement("div");
    brandingDiv.setAttribute("class", "askell-branding")
    document.body.appendChild(modal)
    modal.appendChild(createModalCloseButton())
    modal.appendChild(createIframe(planId, reference, amount, redirect))
    modal.appendChild(brandingDiv)
    
    modal.appendChild(createModalFooter())
    document.body.appendChild(createModalOverlay())
}

const closeModal = () => {
    var modal = document.getElementById("askell-modal")
    var modalOverlay = document.getElementById("askell-modal-overlay")
    document.body.removeChild(modal)
    document.body.removeChild(modalOverlay)
    var iframe = document.getElementById("askell-iframe")
}


ready(() => {
    if (window.askellPaymentButtons) { return false;}
    appendStyleSheet();
    let buttons = document.querySelectorAll('.askell-payment-button');
    console.log(buttons)
    for(let button of buttons) {
        button.addEventListener("click", () => {
            let key = button.getAttribute("data-key");
            let reference = button.getAttribute("data-reference");
            let amount = button.getAttribute("data-amount");
            let redirect = button.getAttribute("data-redirect-url");
            let configuration = JSON.parse(atob(key))
            openPaymentModal(configuration, reference, amount, redirect)
        })
    }
    window.askellPaymentButtons = true;

    window.addEventListener("message", function(event) {
        if (event.data === "askell-close-modal") {
            closeModal()
        } else if (event.data && event.data.event && event.data.event === "askell-sale-complete") {
            window.location.href = event.data.redirect
        }
      }, false);
})
